import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as MenuDotsIcon } from 'static/svg/menu-dots-icon.svg'
import ModalGeneric from '../ModalGeneric'

import * as S from './styles'

interface BlockScheduleModalProps {
  onClose: () => void
  hasCloseButton: boolean
  buttonText: string
  buttonAction: () => void
}

export function BlockScheduleModal({ onClose, buttonText, hasCloseButton, buttonAction }: BlockScheduleModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle='Não é possível agendar com outro psicólogo(a) enquanto você possuir uma reserva.'
      btnText={buttonText}
      onCloseModal={onClose}
      btnOnClick={buttonAction}
      hasButton
      hasCloseButton={hasCloseButton}
    > 
      <S.Container>
        <Typography variant="content2">
          A reserva é um compromisso de exclusividade com o seu psicólogo.
        </Typography>
        <Typography variant="content2">
          Se quiser marcar consulta com outro psicólogo por meio de seu convênio, é necessário cancelar a sua reserva.
        </Typography>
        <Typography variant="content2" customClassName='text'>
          Para cancelar a reserva, acesse o ícone <span className='icon'><MenuDotsIcon /></span> no bloco de informações da reserva, em sua página inicial.
        </Typography>
      </S.Container>
    </ModalGeneric>
  )
}